export const valueIsNullOrUndefined = (value: unknown) => value === undefined || value === null;

export const isNumeric = (value: string | number) => {
  const innerValue: string = typeof value === 'number' ? value.toString() : value;
  return !isNaN(parseFloat(innerValue)) && isFinite(innerValue as unknown as number);
};
